import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\wamp64\\www\\cyberstone\\components\\IndustryCard\\IndustryCard.tsx");
